import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLanguage } from '../i18n/LanguageContext';
export const LanguageModal = () => {
  const {
    lang,
    setLang
  } = useLanguage();
  return <AnimatePresence data-id="element-132">
      {lang === null && <motion.div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/80 backdrop-blur-md" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.5
    }} data-id="element-133">
          <div className="bg-[#0A0A0A] border border-white/10 p-10 md:p-16 rounded-3xl shadow-[0_0_50px_rgba(212,175,55,0.15)] text-center max-w-2xl w-[90%]" data-id="element-134">
            <motion.h2 className="text-2xl md:text-4xl font-serif font-bold text-white mb-12" initial={{
          y: 20,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          delay: 0.2
        }} data-id="element-135">
              Choose your language
              <br data-id="element-136" />
              <span className="text-primary mt-2 block text-xl md:text-3xl" data-id="element-137">
                Elegí tu idioma
              </span>
            </motion.h2>

            <div className="flex flex-col sm:flex-row gap-6 justify-center" data-id="element-138">
              <motion.button className="relative group overflow-hidden bg-[#111] border border-white/10 text-white font-bold text-lg py-5 px-10 rounded-xl hover:border-primary hover:text-primary transition-all duration-300" initial={{
            x: -20,
            opacity: 0
          }} animate={{
            x: 0,
            opacity: 1
          }} transition={{
            delay: 0.4
          }} whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} onClick={() => setLang('es')} data-id="element-139">
                🇪🇸 Español
              </motion.button>

              <motion.button className="relative group overflow-hidden bg-[#111] border border-white/10 text-white font-bold text-lg py-5 px-10 rounded-xl hover:border-primary hover:text-primary transition-all duration-300" initial={{
            x: 20,
            opacity: 0
          }} animate={{
            x: 0,
            opacity: 1
          }} transition={{
            delay: 0.5
          }} whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} onClick={() => setLang('en')} data-id="element-140">
                🇺🇸 English
              </motion.button>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
};